import { useEffect, useState } from "react";
import { api, type APIResult } from "../../api/client";
import { PageHeader } from "../PageHeader";
import { ResponseCard } from "../ResponseCard";
import { SectionCard } from "../SectionCard";

// Tab de probes — exercita os dois health endpoints expostos pela
// RouteCore via BFF.
export function TabHealth() {
  const [healthResult, setHealthResult] = useState<APIResult<unknown> | null>(null);
  const [healthLoading, setHealthLoading] = useState(false);
  const [readyResult, setReadyResult] = useState<APIResult<unknown> | null>(null);
  const [readyLoading, setReadyLoading] = useState(false);

  async function runHealth() {
    setHealthLoading(true);
    setHealthResult(null);
    const r = await api.upstreamHealth();
    setHealthResult(r);
    setHealthLoading(false);
  }

  async function runReady() {
    setReadyLoading(true);
    setReadyResult(null);
    const r = await api.upstreamReady();
    setReadyResult(r);
    setReadyLoading(false);
  }

  useEffect(() => {
    void runHealth();
    void runReady();
  }, []);

  return (
    <div className="space-y-4">
      <PageHeader
        title="Probes"
        subtitle="Checagens leves de liveness e readiness expostas pela RouteCore."
      />

      <div className="grid gap-4 lg:grid-cols-2">
        <SectionCard
          title="/health"
          description="Liveness — não consulta upstreams. Responde imediatamente quando o processo está vivo."
          actions={
            <button
              type="button"
              className="ks-btn-primary text-xs"
              disabled={healthLoading}
              onClick={runHealth}
            >
              {healthLoading ? "checando..." : "Checar"}
            </button>
          }
        >
          <ResponseCard result={healthResult} loading={healthLoading} />
        </SectionCard>

        <SectionCard
          title="/ready"
          description="Readiness profunda — checa Postgres + Redis + Kafka em paralelo (2s cada). Recomendado para gateways de trás."
          actions={
            <button
              type="button"
              className="ks-btn-primary text-xs"
              disabled={readyLoading}
              onClick={runReady}
            >
              {readyLoading ? "checando..." : "Checar"}
            </button>
          }
        >
          <ResponseCard result={readyResult} loading={readyLoading} />
        </SectionCard>
      </div>
    </div>
  );
}
